import { useSelector } from "react-redux";

const useServiceChecker = () => {
  const services = useSelector((state) => state.refreshToken.services);

  const ensureAll = (passedServices) => {
    const missing = passedServices.filter((val) => !services?.includes?.(val));
    if (missing.length === 0) {
      return { status: true };
    }
    return {
      status: false,
      unavailableService: {
        unavailableService: missing,
      },
    };
  };

  const ensureAny = (passedServices) => {
    const hasAny = passedServices.some((val) => services?.includes?.(val));
    const missing = passedServices.filter((val) => !services?.includes?.(val));

    if (hasAny) {
      return { status: true };
    }
    return {
      status: false,
      unavailableService: {
        unavailableService: missing,
      },
    };
  };

  return [ensureAll, ensureAny];
};

export default useServiceChecker;
